var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Unplanned Icon",
  d: "M21.6 31.2h4.8V36h-4.8Zm0-19.2h4.8v14.4h-4.8Zm2.376-12A24 24 0 1 0 48 24 23.988 23.988 0 0 0 23.976 0ZM24 43.2A19.2 19.2 0 1 1 43.2 24 19.195 19.195 0 0 1 24 43.2Z"
})));
export default SvgInfoIcon;